import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../services/logged/auth.service';
import { ProgresoUsuarioService } from '../../../services/progreso-usuario/progreso-usuario.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: []
})
export class LoginComponent implements OnInit {
  title = "Inicia Sesión";
  loginForm!: FormGroup;
  loading = false;
  submitted = false;
  errorMessage = '';
  isPasswordVisible: boolean = false;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private progresoUsuarioService: ProgresoUsuarioService 
  ) {}

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      contrasena: ['', Validators.required]
    });
  }

  get f() { return this.loginForm.controls; }

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
  
    this.loading = true;
    this.authService.login(this.f['email'].value, this.f['contrasena'].value).subscribe({
      next: (res) => {
        this.progresoUsuarioService.checkInitialStatusAndProgress();
        this.loading = false;
      },
      error: (error) => {
        this.errorMessage = error.error.message || 'Email o contraseña incorrecta';
        this.loading = false;
      }
    });
  }
}
